/* eslint-disable no-sequences */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useCallback, useEffect, useMemo, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

import AgentsTableHeader from "./sub/AgentsTableHeader/index";
import AgentsTableBody from "./sub/AgentsTableBody/index";
import AgentsTableFooterGuide from "./sub/AgentsTableFooter/index";

import { getAgents } from "../../../../../../../../store/manager/actions";
import { useDidUpdateEffect } from '../../../../../../../../hooks/useDidUpdateEffect'

import "./AgentsTable.scss";
import { useInView } from 'react-intersection-observer';


const Index = ({ onExpand }) => {
  const [ref, inView] = useInView({
    threshold: 0,
  });
  const dispatch = useDispatch();
  const { dataAgent, loadingAgent, dataGeneralFilter } = useSelector((state) => state.Manager);
  const { skills, groups } = useMemo(() => {
    const { skills = [], groups = [] } = dataGeneralFilter ?? {}
    return { skills, groups }
  }, [dataGeneralFilter])

  const total = useMemo(() => dataAgent?.count ?? 0, [dataAgent])
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState(['online', 'away', 'backsoon'])
  const [name, setName] = useState('')
  const hasNextPage = useMemo(() => {
    if (!total) return false

    const pages = Math.ceil(total / 40)

    return pages > page
  }, [total, page])

  const toggleStatus = useCallback((stat, use) => {
    setStatus(status => {
      if (use) return status.includes(stat) ? status : [...status, stat]
      return status.includes(stat) ? status.filter(inStat => stat !== inStat) : status
    })
  }, [])

  const [showMode, setShowMode] = useState({ cardMode: true, listMode: false });

  const agents = useMemo(() => dataAgent?.agents ?? [], [dataAgent])

  const fetch = useCallback(() => {
    dispatch(getAgents(page, 40, { status, name, skills, groups }))
  }, [dispatch, page, status, name, skills, groups])

  useDidUpdateEffect(() => setPage(1), [status])

  useEffect(() => {
    fetch();
  }, [fetch])

  useEffect(() => {
    let intervalId;

    if (inView) {
      intervalId = setInterval(fetch, 60000); 
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [inView, fetch]);

  const { online, backsoon, offline } = useMemo(() => {
    const { online = 0, backsoon = 0, away: offline = 0 } =
      dataAgent?.stats.reduce((acc, stat) => ({ ...acc, [stat.type]: stat.count }), {}) ?? {}
    return { online, backsoon, offline }
  }, [dataAgent])

  return (
    <>
      <div className="mt-4 px-2" ref={ref}>
        <AgentsTableHeader
          searchFilterValueReceived={setName}
          filterInputValue={name}
          loadingData={loadingAgent}
          handleRefresh={fetch}
          requestResult={total}
          backsoonAgentsQtd={backsoon}
          onlineAgentsQtd={online}
          offlineAgentsQtd={offline}
          backsoonFilterClicked={(use) => toggleStatus('backsoon', use)}
          onlineFilterClicked={(use) => toggleStatus('online', use)}
          offlineFilterClicked={(use) => toggleStatus('away', use)}
          onExpand={onExpand}
          onCardButtonClick={() => setShowMode({ listMode: false, cardMode: true })}
          onListButtonClick={() => setShowMode({ listMode: true, cardMode: false })}
          showMode={showMode}
        />
        <AgentsTableBody
          handleRefresh={fetch}
          loadingData={loadingAgent}
          payloadData={agents}
          isAgentCard={showMode.cardMode}
        />
      </div>
      <hr className="conversation-table-separator" />
      <div className="d-flex justify-content-end agents-table-footer mb-3">
        <AgentsTableFooterGuide
          minimumAgentNumber={(page - 1) * 40 + 1}
          maxAgentNumber={(page - 1) * 40 + agents.length}
          totalAgentNumber={total}
          page={page}
        />
        <Pagination className="d-flex justify-content-around mt-2 mr-3">
          <PaginationItem disabled={page === 1}>
            <PaginationLink previous onClick={() => setPage(page => Math.max(1, page - 1))}/>
          </PaginationItem>
          <PaginationItem active>
            <PaginationLink>{page}</PaginationLink>
          </PaginationItem>
          <PaginationItem>
            <PaginationLink next disabled={!hasNextPage} onClick={() => setPage(page => page + 1)}/>
          </PaginationItem>
        </Pagination>
      </div>
    </>
  );
};

export default Index;
